import React from "react";

export function WhatsAppImporter() {
  return (
    <div className="p-4 text-brand-blue">
      <h2 className="text-lg font-bold mb-2">WhatsApp Importer</h2>
      <p className="text-sm text-gray-500">Módulo em desenvolvimento.</p>
    </div>
  );
}
